/*import { throttle } from './ThrottleDebounce.js';*/
const $filter = $('.js-filter');
const $subscribeForm = $('.js-subscribe-form-wrapper');
const $filterForm = $('.js-filter-form');
let pagintaionSwiper;
let resetPaginationFlag;

function getFilter(scrollTop) {
    /*let $paginationInput = App.H.find('.js-page-value');*/
    const formData = $filterForm.serialize();

    if (!scrollTop || resetPaginationFlag) {
        //App.H.find('.js-page-value').val(1);
        resetPagination();
    }

    App.H.find('.js-page-value').prop('disabled', App.H.find('.js-page-value').val() == 1);

    $.ajax({
        url: $filterForm.attr('action'),
        data: formData,
        cache: false,
        success: (response) => {
            const $newContent = $(response).find('.js-blog-content');
            const $newPaging = $(response).find('.js-paging');
            const $newDesktopPaging = $(response).find('.js-desktop-paging');
            const $newFilter = $(response).find('.js-filter-form');

            /* Скроллим к началу товаров, если пагинация */
            if (scrollTop) {
                $('html, body').animate({
                    scrollTop: $filter.offset().top - 160
                }, 500);
            }

            if (window.history) {
                window.history.replaceState({}, '', $filterForm.data('url-root') + '?' + encodeURI(formData));
            }

            if ($newPaging) {
                $('.js-paging').html($newPaging.html());

                if (App.mobile) {
                    genSliderPaging();
                }
            }

            if ($newDesktopPaging.length) {
                $('.js-desktop-paging').html($newDesktopPaging.html());
                $('.js-paging').removeClass('_hidden');
            } else {
                $('.js-paging').addClass('_hidden');
            }

            if ($newContent) {
                $('.js-blog-content').html($newContent.html());
            }

            if ($newFilter) {
                $('.js-filter-form').html($newFilter.html());
            }

            if ($newContent.find('.js-blog-item').length) {
                App.H.removeClass('_no-results');
            } else {
                App.H.addClass('_no-results');
            }

            /*if (window.history) {
                window.history.replaceState({}, '', '?' + formData);
            }*/

            closeFilter();

        },
        error: () => {
            /*setClearButtonsAttr();
            clearFilterPreloader();
            resetPriceDisabled();
            resetAvailableInput();*/
            App.H.removeClass('_filter-loading');
            console.log('Ошибка получения данных фильтра');
        }
    });
}

function closeFilter() {
    $filter.removeClass('_open');
    App.H.removeClass('_popup');
}

function closeSubscribeForm() {
    $subscribeForm.removeClass('_open');
    App.H.removeClass('_popup');
}

function genSliderPaging() {
    let _urlPage = $('.js-page-value').val();
    const initialPage = _urlPage || 1;

    pagintaionSwiper = new Swiper(`.js-paging .js-pagination`, {
        slidesPerView: 7,
        centeredSlides: true,
        paginationClickable: true,
        height: 80,
        initialSlide: initialPage - 1,
        slideToClickedSlide: true
    });

    pagintaionSwiper.on('slideChangeTransitionEnd', () => {
        const id = $('.js-pagination').find('.swiper-slide-active').data('page');

        sendPagingFilter(id);
    });
}

function resetPagination() {
    App.H.find('.js-page-value').val(1);
}

function sendPagingFilter(pageId) {
    App.H.find('.js-page-value').val(pageId);
    getFilter(true);
}

function showCheckedCount() {
    let checkedCount = $('.js-filter-form input[type="checkbox"]:checked').length;

    $('.js-filter-form select').each(function (index, el) {
        if ($(el).val() !== $(el).data('default-val')) {
            checkedCount++;
        }
    });

    checkedCount = checkedCount === 0 ? '' : checkedCount;

    $('.js-checked-count').html(checkedCount);
}

App.D.on('click', '.js-clear-filter', function (e) {
    let $formFilter = $('.js-filter-form');

    $formFilter.find('input[type="checkbox"]').prop('checked', false);
    $formFilter.find('select').each(function (index, el) {
        $(el).find('option').first().prop('selected', true);
    });

    $('.js-checked-count').html('');
    $('.js-page-value').val(1);
    getFilter();

    e.preventDefault();
});

App.D.on('click', '.js-filter-btn', function () {
    $filter.toggleClass('_open');
    //App.H.toggleClass('_filter-open');
    App.H.toggleClass('_popup');
});

/* Пагинация */
App.H.on('click', '.js-paging a', e => {
    e.preventDefault();

    let $currPage = $(e.target);
    let pageId = $currPage.data('page');

    // если мобильный, то свайпим пагиниацию
    if (App.mobile && App.W.outerWidth() < mobileWidth) {
        pagintaionSwiper.slideTo(pageId - 1);
    } else {
        $('.pagination-desktop').find('.swiper-slide-active').removeClass('swiper-slide-active');
        $currPage.addClass('swiper-slide-active');
        App.H.find('.js-page-value').val(pageId);

        resetPaginationFlag = false;
        getFilter(true);
    }
});


App.H.on('change', '.js-filter-form input[type="checkbox"], .js-filter-form select', e => {
    showCheckedCount();

    e.preventDefault();
});

App.H.on('click', '.js-apply-filter', e => {
    getFilter();

    e.preventDefault();
});

App.D.on('mouseup', function(e) {
    if (!$filter.is(e.target) && $filter.has(e.target).length === 0 && $filter.hasClass('_open')) {
        closeFilter();
    }

    if (!$subscribeForm.is(e.target) && $subscribeForm.has(e.target).length === 0 && $subscribeForm.hasClass('_open')) {
        closeSubscribeForm();
    }
});

App.H.on('click', '.js-subscribe-btn', e => {
    $subscribeForm.toggleClass('_open');
    //App.H.toggleClass('_filter-open');
    App.H.toggleClass('_popup');

    e.preventDefault();
});

if (App.mobile) {
    genSliderPaging();
}


// WEBPACK FOOTER //
// ./_src/js/modules/BlogFilter.js